import styled from "styled-components";

interface RadioStyledProps {
  checked: boolean;
}

export const Wrapper = styled.div<RadioStyledProps>`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  align-items: center;
  padding: 6px 8px;
  border-radius: 99px;
  background-color: ${({ checked }) => (checked ? "#77EC8450" : "transparent")};
  
  @media (max-width: 768px) {
    border-radius: 0px;
    flex-direction: column;
    padding: 8px 6px;
    gap: 5px;
  }

  &:hover {
    transition: all 0.2s;
    box-shadow: 0px 0px 2px black;
    background-color: ${({ checked }) => (!checked ? "#77EC8470" : null)};
  }

  input[type="radio"] {
    display: none;
  }

  input[type="radio"] + label {
    width: 100%;
    @media (max-width: 768px) {
    width: fit-content;
  }
  }

  input[type="radio"]:checked {
    & {
      background-color: #77EC8450;
    }
  }
`;
export const Label = styled.label`
  font-size: 1rem;
  color: #2c2c2c;
  line-height: 0;
  user-select: none;
  cursor: pointer;
  padding-left: 4px;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 0.5rem;
    padding-left: 0px;
    
  }
`;
